import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

interface SanitizedHtmlProps {
  /** 서버에서 내려온 HTML 문자열 (렌더링 전에 DOMPurify 로 sanitize) */
  html: string;
  className?: string;
  id?: string;
}

/**
 * HTML 본문을 XSS 방지 처리(DOMPurify) 후 렌더링한다.
 */
export default function SanitizedHtml({ html, className, id }: SanitizedHtmlProps): React.ReactElement {
  const sanitizedHtml = useMemo(() => DOMPurify.sanitize(html.trim()), [html]);
  return <div id={id} className={className} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
}
